import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export interface CertificateType {
    id: number;
    period_id: number;
    name: string;
    code: string;
    source_type?: "convention" | "conference" | "speaker" | "mainroom" | "event_guest" | null;
    description?: string | null;
    is_active: boolean;
    created_at?: string;
    updated_at?: string;
}

export const useAdminCertificateTypes = () => {
    return useQuery({
        queryKey: ["admin-certificate-types"],
        queryFn: async () => {
            const { data } = await axiosClient.get("/private/certificate-types");
            return data.data as CertificateType[];
        },
    });
};

export const useCreateCertificateType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: Partial<CertificateType>) => {
            const { data } = await axiosClient.post("/private/certificate-types", payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-certificate-types"] });
        },
    });
};

export const useUpdateCertificateType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, payload }: { id: number; payload: Partial<CertificateType> }) => {
            const { data } = await axiosClient.put(`/private/certificate-types/${id}`, payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-certificate-types"] });
        },
    });
};

export const useDeleteCertificateType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => {
            const { data } = await axiosClient.delete(`/private/certificate-types/${id}`);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-certificate-types"] });
        },
    });
};

